import type { LucideIcon } from "lucide-react";

interface Props {
    icon: LucideIcon;
    label: string;
    value: string;
    /** One line of context under the number — what it is out of, or beside. */
    caption?: string;
}

/** A headline number. Not a chart: one figure reads better as a figure. */
export default function StatTile({ icon: Icon, label, value, caption }: Props) {
    return (
        <div className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03]">
            <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-tint text-accent-on-tint">
                    <Icon className="h-4 w-4" aria-hidden="true" />
                </span>
                <span className="text-xs font-bold uppercase tracking-wider text-content-tertiary">
                    {label}
                </span>
            </div>
            <div>
                <p className="text-2xl font-semibold tabular-nums text-content-primary">{value}</p>
                {caption && <p className="mt-0.5 text-xs text-content-secondary">{caption}</p>}
            </div>
        </div>
    );
}
